import { CheckSquareOutlined, MessageOutlined, UserOutlined } from '@ant-design/icons';

import { PAGE_NAMES, USER_ROLE } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';

const getProfileMenuConfig = ({
  t,
  lng,
  user,
  isPlatform,
  isAdminPanel,
}: {
  t: (key: string, options: { ns: string[] }) => string;
}) => {
  return [
    {
      link: getLocaleLink(
        isPlatform
          ? PAGE_NAMES.PLATFORM_USER_PROFILE
          : isAdminPanel
            ? PAGE_NAMES.ADMIN_USER_PROFILE
            : PAGE_NAMES.USER_PROFILE,
        lng,
      ),
      text: t('page.user-profile.menu-item', {
        ns: ['page'],
      }),
      icon: <UserOutlined />,
    },
    ...(user?.role === USER_ROLE.USER
      ? [
          {
            link: getLocaleLink(
              isPlatform
                ? PAGE_NAMES.PLATFORM_USER_FAVORITE_TOPICS
                : isAdminPanel
                  ? PAGE_NAMES.ADMIN_USER_FAVORITE_TOPICS
                  : PAGE_NAMES.USER_FAVORITE_TOPICS,
              lng,
            ),
            text: t('page.favorite-topics.menu-item', {
              ns: ['page'],
            }),
            icon: <CheckSquareOutlined />,
          },
        ]
      : []),
    ...[
      {
        link: getLocaleLink(
          isPlatform
            ? PAGE_NAMES.PLATFORM_USER_DIALOGS
            : isAdminPanel
              ? PAGE_NAMES.ADMIN_USER_DIALOGS
              : PAGE_NAMES.USER_DIALOGS,
          lng,
        ),
        text: t('text.support'),
        icon: <MessageOutlined />,
      },
    ],
  ];
};

export default getProfileMenuConfig;
